import { colorsDark } from '../../themes/dark-colors';

export const multiTagDarkTheme = {
  container: {
    backgroundColor: {
      disabled: colorsDark.gray[0],
      selected: colorsDark.blue[300],
      default: colorsDark.blue[100],
      hover: colorsDark.blue[200],
    },
    borderColor: {
      selected: colorsDark.blue[600],
      default: colorsDark.blue[300],
      hover: colorsDark.blue[500],
    },
  },
  closeButton: {
    color: {
      default: colorsDark.royalBlue[500],
      selected: colorsDark.royalBlue[1000],
      hover: colorsDark.blue[200],
    },
  },
  strikeThroughColor: colorsDark.royalBlue[1000],
  stepTextBackgroundColor: colorsDark.blue[200],
  invalid: colorsDark.red[500],
};
